/**
 * Flight Type Selection Component
 * 
 * Allows user to choose between Planned Flight and Quick Flight
 */

import { FC } from 'react';
import { Calendar, Zap } from 'lucide-react';

export type FlightType = 'planned' | 'quick';

interface FlightTypeSelectionProps {
    onSelect: (type: FlightType) => void;
}

interface FlightTypeCardProps {
    title: string;
    icon: React.ReactNode;
    bgColor: string;
    hoverColor: string;
    onClick: () => void;
}

const FlightTypeCard: FC<FlightTypeCardProps> = ({ 
    title, 
    icon, 
    bgColor, 
    hoverColor, 
    onClick 
}) => (
    <button
        type="button"
        onClick={onClick}
        className={`
            ${bgColor} ${hoverColor}
            w-72 h-56 rounded-lg
            flex flex-col items-center justify-center gap-4
            transition-all duration-200
            hover:scale-105 hover:shadow-lg hover:shadow-black/30
            focus:outline-none focus:ring-2 focus:ring-cyan-400 focus:ring-offset-2 focus:ring-offset-slate-950
        `}
    >
        <div className="w-12 h-12 bg-white/20 rounded flex items-center justify-center">
            {icon}
        </div>
        <span className="text-white text-lg font-medium">{title}</span>
    </button>
);

export const FlightTypeSelection: FC<FlightTypeSelectionProps> = ({ onSelect }) => {
    return (
        <div className="flex gap-8 justify-center items-center mt-16">
            <FlightTypeCard
                title="Planned Flight"
                icon={<Calendar className="w-6 h-6 text-white" />}
                bgColor="bg-blue-600"
                hoverColor="hover:bg-blue-500"
                onClick={() => onSelect('planned')}
            />
            <FlightTypeCard
                title="Quick Flight"
                icon={<Zap className="w-6 h-6 text-white" />}
                bgColor="bg-emerald-600"
                hoverColor="hover:bg-emerald-500"
                onClick={() => onSelect('quick')}
            />
        </div>
    );
};
